import { useSlice } from "components/hooks/useSlice";
import { dispatchSlice } from "components/hooks/dispatchSlice";
import getMessageCatalog from "data/actions/getMessageCatalog";

export function useCatalogMessage(set, number) {
  dispatchSlice(getMessageCatalog);

  const { messages = [] } = useSlice("messageCatalog");
  const message = messages.find((m) => m.set === set && m.number === number);

  return message;
}
